import type {ReviewRequestsData} from '../../../page-data/payloads/review-requests'

export function isPRAuthor(viewerLogin: string, authorLogin: string) {
  if (!viewerLogin || !authorLogin) return false

  return viewerLogin.toLowerCase() === authorLogin.toLowerCase()
}

export function isPRReviewer(viewerLogin: string, reviewers: ReviewRequestsData) {
  if (!viewerLogin) return false
  const lower = viewerLogin.toLowerCase()

  const hasPending = reviewers.pendingReviewRequests?.some(req => req.reviewer.displayLogin.toLowerCase() === lower)
  if (hasPending) return true

  const hasCompleted = reviewers.completedReviews?.some(rev => rev.reviewer.displayLogin.toLowerCase() === lower)
  return !!hasCompleted
}

export function viewerActionability(reviewers: ReviewRequestsData, viewerLogin: string, authorLogin: string) {
  const isAuthor = isPRAuthor(viewerLogin, authorLogin)
  const isReviewer = isPRReviewer(viewerLogin, reviewers)

  return {
    isAuthor,
    isReviewer,
    hasActionItems: isAuthor || isReviewer,
  }
}
